__turbopack_context__.v({
  "unavailable_message": "UnavailableMessage-module-scss-module__jhOKGW__unavailable_message",
});
